import { render, staticRenderFns } from "./calendarEventModal.vue?vue&type=template&id=22bed8ba&scoped=true&"
import script from "./calendarEventModal.vue?vue&type=script&lang=js&"
export * from "./calendarEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bed8ba",
  null
  
)

export default component.exports